import { LoginBalanceDto } from "@api-types/user/LoginResponseDto";

export class UserAccount extends LoginBalanceDto {}
